import React from 'react';
import { useRouter } from 'next/router';
import { convertDatasets } from 'src/utils/datasets';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

function SectionThree({ data }: any) {
  const router = useRouter();
  const test =
    '<iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fthepeoplecoofficial%2Fvideos%2F523258593959399%2F&show_text=false&width=560&t=0" width="100%" height="100%" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>';
  console.log(data);
  return (
    <SectionWrapper className='section-three'>
      <img className='background-image' src={convertDatasets(data, 'image-top', true)} />
      <div className='container'>
        <img className='mb-5' src={convertDatasets(data, 'heading-image', true)} />
        {data
          .filter((i: any) => i.key.includes('video_url_'))
          .map((item: any, index: any) => (
            <>
              <div className='frame'>
                <div
                  className='video'
                  dangerouslySetInnerHTML={{
                    __html: convertDatasets(data, `video_url_${index + 1}`, true) || '#'
                  }}
                ></div>
              </div>
              <img className='' src={convertDatasets(data, `section-text-${index + 1}`, true)} />
            </>
          ))}
      </div>
      <img className='image-bottom' src={convertDatasets(data, 'image-top', true)} />
      <div className='container '>
        <img className='image-right' src={convertDatasets(data, 'image-right', true)} />
        <img className='image-left' src={convertDatasets(data, 'image-left', true)} />
      </div>

      <div className='container'>
        <img className='' src={convertDatasets(data, 'ending-image', true)} />
        <div className='info-wrapper'>
          <a
            className='register-button'
            href={convertDatasets(data, 'link-read', true)}
            // ! DATALAYER
            onClick={() => {
              sendDataLayerGlobal({
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router.pathname,
                section: 'section-3',
                position: 'on:vejpongosot120years-page',
                data: {
                  heading: convertDatasets(data, 'link-read', true)
                }
              });
            }}
          >
            <img className='button-read' src={convertDatasets(data, 'button-read', true)} />
          </a>
        </div>
      </div>
    </SectionWrapper>
  );
}
const SectionWrapper = styled.div`
  position: relative;
  width: 100vw;

  .mb-5 {
    margin-bottom: 5rem;

    @media (max-width: 475px) {
      margin-bottom: 2rem;
    }
  }

  .container {
    position: relative;

    .text {
      position: absolute;
      color: #fff;
      font-size: 65px;
      font-weight: 600;
      top: 8%;
      left: 10%;
      line-height: 1.2;

      @media (max-width: 992px) {
        font-size: 44px;
      }

      @media (max-width: 475px) {
        font-size: 20px;
      }
    }
  }

  .background-image {
    max-height: 600px;
  }

  .info-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 40px 0px;
  }

  .register-button {
    width: 10%;
    display: flex;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    cursor: pointer;

    &:hover {
      // background-color: #f8f9f8;
      // color: #b30e0e;
    }

    @media (max-width: 992px) {
      // font-size: 28px;
    }

    @media (max-width: 475px) {
      width: 25%;
    }
  }

  .image-right {
    position: absolute;
    width: 180px;
    bottom: 25px;
    left: 9rem;

    @media (max-width: 992px) {
      width: 110px;
      bottom: 25px;
      left: 9rem;
    }

    @media (max-width: 475px) {
      width: 60px;
      bottom: -10px;
      left: 4rem;
    }
  }

  .image-left {
    position: absolute;
    width: 150px;
    bottom: 140px;
    right: 15rem;

    @media (max-width: 992px) {
      width: 90px;
      bottom: 45px;
      right: 15rem;
    }

    @media (max-width: 475px) {
      width: 50px;
      bottom: 20px;
      right: 4rem;
    }
  }

  .image-bottom {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    max-height: 600px;
  }

  img {
    width: 100%;
  }

  .frame {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 0px;

    @media (max-width: 475px) {
      padding: 25px 0px;
    }
  }

  .video {
    width: 100%;
    height: auto;
    position: relative;
    aspect-ratio: 16/9;

    @media (max-width: 992px) {
      width: 100%;
      margin-bottom: 0;
    }

    .button-read {
      width: 20%;
      cursor: pointer;

      @media (max-width: 992px) {
        width: 65%;
      }

      @media (max-width: 475px) {
        width: 75%;
      }
    }
  }
`;

export default SectionThree;
